import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ErrorCode } from '@app-shared/enums';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const messageService = inject(NzMessageService);
  const notificationService = inject(NzNotificationService);

  return next(req).pipe(
    catchError((res: HttpErrorResponse) => {
      const { error_code } = res.error;
      let message = '';
      if (!req.url.includes('auth/me')) {
        switch (error_code) {
          case ErrorCode.VALIDATION_ERROR:
            message = '入力内容に誤りがあります。';
            break;
          case ErrorCode.DATABASE_ERROR:
            message = 'データベースエラーが発生しました。';
            break;
          case ErrorCode.INTERNAL_SERVER_ERROR:
            message =
              'システムエラーが発生しました。しばらくしてから再度お試しください。';
            break;
          case ErrorCode.RESOURCE_NOT_FOUND:
            message = '対象のデータが見つかりません。';
            break;
          case ErrorCode.UNAUTHENTICATED:
            message = 'ログインIDまたはパスワードが間違っています。';
            break;
          case ErrorCode.FORBIDDEN:
            message = 'この操作を行う権限がありません。';
            break;
          case ErrorCode.MASTER_CANNOT_PERFORM_IN_TENANT:
            message = 'マスター管理者はテナント操作を実行できません。';
            break;
          case ErrorCode.PREFECTURE_NOT_EXITS:
            message = '指定された都道府県が存在しません。';
            break;
          case ErrorCode.INTERNAL_SERVER_ERROR:
            message =
              'システムエラーが発生しました。しばらくしてから再度お試しください。';
            break;
          case ErrorCode.LINE_INVALID_CREDENTIALS:
            message = 'LINEの認証情報が正しくありません。';
            break;
          case ErrorCode.LINE_CONNECTION_FAILED:
            message = 'LINEとの接続に失敗しました。';
            break;
          case ErrorCode.LINE_FETCH_FRIENDS_FAILED:
            message = 'LINE友だち情報の取得に失敗しました。';
            break;
          case ErrorCode.LINE_ACCOUNT_NOT_FOUND:
            message = 'LINE公式アカウントが見つかりません。';
            break;
          case ErrorCode.LINE_ACCOUNT_EXISTS:
            message = 'このLINE公式アカウントは既に登録されています。';
            break;
          case ErrorCode.LINE_ACCOUNT_CANNOT_ATTACH_WEBHOOK:
            message = 'Webhookの設定に失敗しました。';
            break;
          case ErrorCode.LINE_ACCOUNT_INACTIVE:
            message = 'このLINE公式アカウントは無効状態です。';
            break;
          case ErrorCode.CREATE_TENANT_FAILED:
            message = 'テナントの作成に失敗しました。';
            break;
          case ErrorCode.TEST_PUSH_ERROR:
            message = 'テスト配信に失敗しました。';
            break;
          case ErrorCode.CREATE_DELIVERY_MESSAGE_ERROR:
            message = '配信メッセージの作成に失敗しました。';
            break;
          case ErrorCode.DELIVERY_MESSAGE_UPLOAD_CONTENT_FILE_ERROR:
            message = '配信コンテンツファイルのアップロードに失敗しました。';
            break;
          case ErrorCode.DELIVERY_MESSAGE_DO_NOT_TEST_PUSH:
            message = 'テスト配信が未実施のため、本配信できません。';
            break;
          case ErrorCode.DELIVERY_MESSAGE_UPLOAD_LIMITED:
            message = 'アップロード可能なファイル数を超えています。';
            break;
          case ErrorCode.DELIVERY_MESSAGE_ALREADY_SCHEDULED:
            message = 'この配信は既にスケジュールされています。';
            break;
          case ErrorCode.DELIVERY_MESSAGE_CONTENT_INVALID:
            message = '配信内容が正しくありません。';
            break;
          case ErrorCode.DELIVERY_MESSAGE_CANNOT_CANCEL_MESSAGE:
            message = 'この配信はキャンセルできません。';
            break;
          case ErrorCode.DELIVERY_MESSAGE_DEADLINE_HAS_PASSED:
            message = '配信期限を過ぎているため、操作できません。';
            break;
          case ErrorCode.DELIVERY_MESSAGE_CANNOT_DESTROY_MESSAGE:
            message = 'この配信は削除できません。';
            break;
          case ErrorCode.DELIVERY_MESSAGE_CANNOT_UPDATE_MESSAGE:
            message = 'この配信は編集できません。';
            break;
          case ErrorCode.DELIVERY_MESSAGE_CANNOT_SCHEDULED_WITH_INACTIVE_FRIEND:
            message =
              '友だち追加していないユーザーのため、メッセージを送信することができません。';
            break;
          case ErrorCode.CANNOT_RESET_MASTER_PASSWORD:
            message = 'マスター管理者のパスワードはリセットできません。';
            break;
          case ErrorCode.ALREADY_RESET_PASSWORD:
            message = 'このパスワードは既にリセットされています。';
            break;
          default:
            message = '処理が失敗しました';
            break;
        }

        const array = ['auth/login', 'auth/password-reset'];
        if (array.some((api) => req.url.includes(api))) {
          notificationService.error('エラー', message);
        } else if (!req.url.includes('auth/logout')) {
          messageService.error(message);
        }
      }
      if (res.status === 401) {
        authService.clearUser();
        router.navigate(['/login']);
      } else if (res.status === 404) {
        router.navigate(['exception', '404']);
      } else if (res.status === 500) {
        router.navigate(['exception', '500']);
      }
      return throwError(res);
    }),
  );
};
